import { featuresData } from '@/mocks/home-data';

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-2">为什么选择我们</h2>
          <p className="text-sm text-foreground-600">四大核心优势 · 做最值得信赖的吃瓜平台</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {featuresData.map((item) => (
            <div
              key={item.id}
              className="text-center p-6 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer group"
            >
              <span className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 rounded-2xl bg-accent-100 group-hover:bg-accent-200 transition-colors">
                <i className={`${item.icon} text-accent-600 text-2xl`}></i>
              </span>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}